// ContactUsFormComenTopBanner.jsx

import React from 'react';
//import Logo from '../images/PHOENIXSOLUTION-1.png';
import '../../styles/ComenTopBanner.scss';
import '../../styles/ContactUsForm/ContactUsFormComenTopBanner.scss';
import ArrowWhite from '../../images/Icon/btn-arrow-white.svg';

const ContactUsFormComenTopBanner = () => {
    const scrollToContactUsForm = () => {
        const aboutSection = document.getElementById('ContactUsForm-section');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      };
    return (
        <>
            <section className="Comen-top-banner ContactUsFormComenTopBanner">
                <div className="container">
                    <div className="Comen-top-banner-background"></div>
                </div>
                <div className="Comen-top-banner-cont">
                    <h1>CONTACT US </h1>
                    <span className="cursive-font">Phoenix Solutions</span>
                </div>
                <div className="scroll-down-arrow" onClick={scrollToContactUsForm}>
                    {/* &#x25BC; Downward arrow symbol */}
                    <i>
                        <img src={ArrowWhite} alt="btn-arrow-white" />
                    </i>
                </div>
            </section>
        </>
    );
};

export default ContactUsFormComenTopBanner;
